import chunk from 'lodash/chunk';
import initial from 'lodash/initial';

interface Discourse {
  speaker: string;
  dialogue: string;
}

export const formatTranscript = (text: string): Discourse[] => {
  // Make sure we remove pesky new line at the end of the file!
  const lines = initial(text.split('\n'));
  const chunks = chunk(lines, 3);
  const discourse = chunks.map((line) => ({
    speaker: line[0],
    dialogue: line[1],
  }));

  return discourse;
};
